import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorText,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorCnpj,
    TextValidatorTextMultiline,
    TextValidatorDiaRequired,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextFieldTextSelect,
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonClearEntradaDados,
} from '../../../business-components/IconButton/IconButton'

//import tipoRecursoFinanceiroList from '../../../business-rules/List/tipoRecursoFinanceiroList'

import tipoRecursoFinanceiroEntradaDadosList from '../../../business-rules/List/tipoRecursoFinanceiroEntradaDadosList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoRegimeTributacaoList from '../../../business-rules/List/tipoRegimeTributacaoList'

import tipoMomentoTributacaoIRList from '../../../business-rules/List/tipoMomentoTributacaoIRList'

import {
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    atualizaPerguntaValor,
} from '../form-form/FormServicePerguntas'

import {
    processaAlteracaoRecursosFinanceirosTipoRecursoFinanceiro,
    processaAlteracaoRecursosFinanceirosControlarAportes,
    processaAlteracaoRecursosFinanceirosPercRecursosFinanceirosCliente,
    tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList,
    origemRealocacaoCarteiraInvestimentos,
} from './GarantiasServiceRecursosFinanceiros'



export const TablePaginationPadraoRecursosFinanceiros = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.recursosFinanceirosPagination}
            nameRowsPerPage={'rowsPerPageRecursosFinanceiros'}
            namePage={'pageRecursosFinanceiros'}
            rowsPerPage={values.rowsPerPageRecursosFinanceiros}
            page={values.pageRecursosFinanceiros}
        />
    )
}

export const rowPertentePageRecursosFinanceiros = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageRecursosFinanceiros, values.rowsPerPageRecursosFinanceiros)
}

export const setPageInclusaoRecursosFinanceiros = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageRecursosFinanceiros', values.recursosFinanceirosPagination, values.rowsPerPageRecursosFinanceiros)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`recursosFinanceiros[${ind}].familiar`}
            label={LABEL.familiarInventario}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalRecursosFinanceiros}
            disabled={expandiu}
        />
    )
}

export const TipoRecursoFinanceiro = ({ TextFieldNumberSelectTipoRecursoFinanceiro, values, item, ind,
    handleChange/*, jsonConfiguracao*/, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoRecursoFinanceiro
            name={`recursosFinanceiros[${ind}].tipoRecursoFinanceiro`}
            placeholder={LABEL.tipoRecursoFinanceiro}
            value={item.tipoRecursoFinanceiro || ''}
            onChange={handleChange}
            list={
                //item.idReceitaMensal > 0
                //    ?
                //        tipoRecursoFinanceiroList
                //    :
                        tipoRecursoFinanceiroEntradaDadosList(item.familiar, item.tipoRecursoFinanceiro)
            }
            onBlur={
                processaAlteracaoRecursosFinanceirosTipoRecursoFinanceiro(
                    values, item/*, jsonConfiguracao*/
                )
            }
            //disabled={item.idReceitaMensal > 0}
            disabled={expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosRecursosFinanceiros = ({ values, setFieldValue, item, ind, arrayHelpers, simplificado }) => {

    return (
        /*!item.idReceitaMensal && */!item.idPergunta && !simplificado && !origemRealocacaoCarteiraInvestimentos(values, item)
            ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageRecursosFinanceiros', values.recursosFinanceirosPagination,
                            values.rowsPerPageRecursosFinanceiros, values.pageRecursosFinanceiros)
                    }}
                />
            :
                ''
    )
}

export const Valor = ({ values, item, ind, handleChange, tipoRecursoFinanceiroSelecionado, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`recursosFinanceiros[${ind}].valor`}
            label={tipoRecursoFinanceiroSelecionado.informaReservaAtual === "S" 
                ? LABEL.valorReservaAtual
                : LABEL.valor}
            value={item.valor || ''}
            onChange={handleChange}
            onBlur={atualizaPerguntaValor(values, item.idPergunta, item.valor)}
            //disabled={item.idReceitaMensal > 0}
            disabled={expandiu}
        />
    )
}

export const ValorAporteDividendos = ({ item, ind, handleChange, tipoRecursoFinanceiroSelecionado, expandiu }) => {

    return (
        <TextValidatorValor
            name={`recursosFinanceiros[${ind}].valorAporteDividendos`}
            label={
                tipoRecursoFinanceiroSelecionado.labelDividendos
                    ?
                        tipoRecursoFinanceiroSelecionado.labelDividendos
                    :
                        LABEL.valorAporte
            }
            value={item.valorAporteDividendos || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const ValorAporteEmpresa = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`recursosFinanceiros[${ind}].valorAporteEmpresa`}
            label={LABEL.valorAporteEmpresa}
            value={item.valorAporteEmpresa || ''}
            onChange={handleChange}
        />
    )
}

export const TipoPeriodicidadeAporteDividendos = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelect
            name={`recursosFinanceiros[${ind}].tipoPeriodicidadeAporteDividendos`}
            label={LABEL.tipoPeriodicidadeAporteDividendos}
            value={item.tipoPeriodicidadeAporteDividendos || ''}
            onChange={handleChange}
            list={tipoPeriodicidadeList(false, true, false)}
            disabled={expandiu}
        />
    )
}

export const MesAnoInicialAporteDividendos = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`recursosFinanceiros[${ind}].mesAnoInicialAporteDividendos`}
            label={
                item.tipoPeriodicidadeAporteDividendos === HARDCODE.idTipoPeriodicidadeUnica
                    ?
                        LABEL.mesAno
                    :
                        LABEL.mesAnoInicial
            }
            value={item.mesAnoInicialAporteDividendos || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const MesAnoFinalAporteDividendos = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`recursosFinanceiros[${ind}].mesAnoFinalAporteDividendos`}
            label={LABEL.mesAnoFinal}
            value={item.mesAnoFinalAporteDividendos || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const AporteDividendosAteAposentadoria = ({ item, ind, handleChange, tipoRecursoFinanceiroSelecionado }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].aporteDividendosAteAposentadoria`}
            label={
                tipoRecursoFinanceiroSelecionado.labelDividendosAteAposentadoria
                    ?
                        tipoRecursoFinanceiroSelecionado.labelDividendosAteAposentadoria
                    :
                        LABEL.aporteAteAposentadoria
            }
            checked={item.aporteDividendosAteAposentadoria}
            onChange={handleChange}
        />
    )
}

export const AporteOriundoReceitaMensal = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].aporteOriundoReceitaMensal`}
            label={LABEL.aporteOriundoReceitaMensal}
            checked={item.aporteOriundoReceitaMensal}
            onChange={handleChange}
        />
    )
}

export const HelpAporteOriundoReceitaMensal = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.aporteOriundoReceitaMensal}
            helpText={HELPTEXT.aporteOriundoReceitaMensal}
        />
    )
}

export const AporteOriundoRealocacaoCarteiraInvestimentos = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].aporteOriundoRealocacaoCarteiraInvestimentos`}
            label={LABEL.aporteOriundoRealocacaoCarteiraInvestimentos}
            checked={item.aporteOriundoRealocacaoCarteiraInvestimentos}
            onChange={handleChange}
        />
    )
}

export const HelpAporteOriundoRealocacaoCarteiraInvestimentos = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.aporteOriundoRealocacaoCarteiraInvestimentos}
            helpText={HELPTEXT.aporteOriundoRealocacaoCarteiraInvestimentos}
        />
    )
}

export const RecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos = ({ values, item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelectRequired
            name={`recursosFinanceiros[${ind}].idRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos`}
            label={LABEL.idRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos}
            value={item.idRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos || ''}
            onChange={handleChange}
            list={tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList(values, item)}
        />
    )
}

export const ControlarAportes = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].controlarAportes`}
            label={LABEL.controlarAportes}
            checked={item.controlarAportes}
            onChange={handleChange}
            onBlur={
                processaAlteracaoRecursosFinanceirosControlarAportes(item)
            }
        />
    )
}

export const DiaAporte = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorDiaRequired
            name={`recursosFinanceiros[${ind}].diaAporte`}
            label={LABEL.diaAporte}
            value={item.diaAporte || ''}
            onChange={handleChange}
        />
    )
}

export const PercRecursosFinanceirosCliente = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`recursosFinanceiros[${ind}].percRecursosFinanceirosCliente`}
            label={LABEL.perc + " " + tituloCliente(values)}
            value={item.percRecursosFinanceirosCliente === 0 ? 0 : item.percRecursosFinanceirosCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            onBlur={processaAlteracaoRecursosFinanceirosPercRecursosFinanceirosCliente(values, item)
            }
        />
    )
}

export const PercRecursosFinanceirosConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRecursosFinanceirosConjuge`}
            label={LABEL.perc + " " + tituloConjuge(values)}
            value={item.percRecursosFinanceirosConjuge === 0 ? 0 : item.percRecursosFinanceirosConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={true}
        />
    )
}

export const NaoInventariar = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].naoInventariar`}
            label={LABEL.naoInventariar}
            checked={item.naoInventariar}
            onChange={handleChange}
        />
    )
}

export const HelpNaoInventariar = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.naoInventariar}
            helpText={HELPTEXT.naoInventariarRecursosFinanceiros}
        />
    )
}

export const PercDespesasAdvocaticias = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percDespesasAdvocaticias`}
            label={LABEL.percDespesasAdvocaticias}
            value={item.percDespesasAdvocaticias === 0 ? 0 : item.percDespesasAdvocaticias || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercCustasJudiciais = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percCustasJudiciais`}
            label={LABEL.percCustasJudiciais}
            value={item.percCustasJudiciais === 0 ? 0 : item.percCustasJudiciais || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercInventarioItcmd = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percInventarioItcmd`}
            label={LABEL.percItcmd}
            value={item.percInventarioItcmd === 0 ? 0 : item.percInventarioItcmd || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const NaoConsiderarGarantiaMorteInvalidezCliente = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].naoConsiderarGarantiaMorteInvalidezCliente`}
            label={LABEL.naoConsiderarGarantiaMorteInvalidez + ' ' + tituloCliente(values)}
            checked={item.naoConsiderarGarantiaMorteInvalidezCliente}
            onChange={handleChange}
        />
    )
}

export const NaoConsiderarGarantiaMorteInvalidezConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`recursosFinanceiros[${ind}].naoConsiderarGarantiaMorteInvalidezConjuge`}
            label={LABEL.naoConsiderarGarantiaMorteInvalidez + ' ' + tituloConjuge(values)}
            checked={item.naoConsiderarGarantiaMorteInvalidezConjuge}
            onChange={handleChange}
        />
    )
}

export const HelpNaoConsiderarGarantiaMorteInvalidez = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.naoConsiderarGarantiaMorteInvalidez}
            helpText={HELPTEXT.naoConsiderarGarantiaMorteInvalidezRecursoFinanceiro}
        />
    )
}

export const TipoRegimeTributacao = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`recursosFinanceiros[${ind}].tipoRegimeTributacao`}
            label={LABEL.tipoRegimeTributacao}
            value={item.tipoRegimeTributacao || ''}
            onChange={handleChange}
            list={tipoRegimeTributacaoList}
        />
    )
}

export const NomeFundo = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`recursosFinanceiros[${ind}].nomeFundo`}
            label={LABEL.nomeFundo}
            value={item.nomeFundo || ''}
            onChange={handleChange}
            tamMax={TAMMAX.nomeFundo}
        />
    )
}

export const CnpjFundo = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorCnpj
            name={`recursosFinanceiros[${ind}].cnpjFundo`}
            label={LABEL.cnpjFundo}
            value={item.cnpjFundo || ''}
            onChange={handleChange}
        />
    )
}

export const Instituicao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`recursosFinanceiros[${ind}].instituicao`}
            label={LABEL.instituicao}
            value={item.instituicao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.instituicao}
            disabled={expandiu}
        />
    )
}

export const DataInicioRecursoFinanceiro = ({ item, ind, setFieldValue }) => {

    return (
        <MuiPickersUtilsProviderPadrao>
            <KeyboardDatePickerPadrao
                name={`recursosFinanceiros[${ind}].dataInicioRecursoFinanceiro`}
                label={LABEL.dataInicioRecursoFinanceiro}
                value={item.dataInicioRecursoFinanceiro}
                onChange={(date) =>
                    setFieldValue(
                        `recursosFinanceiros[${ind}].dataInicioRecursoFinanceiro`,
                        date
                    )
                }
            />
        </MuiPickersUtilsProviderPadrao>
    )
}

export const PercRentabilidadeMesRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRentabilidadeMesRecursoFinanceiro`}
            label={LABEL.percRentabilidadeMes}
            value={item.percRentabilidadeMesRecursoFinanceiro === 0 ? 0 : item.percRentabilidadeMesRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercCDIMesRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percCDIMesRecursoFinanceiro`}
            label={LABEL.percCDI}
            value={item.percCDIMesRecursoFinanceiro === 0 ? 0 : item.percCDIMesRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercRentabilidadeAnoRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRentabilidadeAnoRecursoFinanceiro`}
            label={LABEL.percRentabilidadeAno}
            value={item.percRentabilidadeAnoRecursoFinanceiro === 0 ? 0 : item.percRentabilidadeAnoRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercCDIAnoRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percCDIAnoRecursoFinanceiro`}
            label={LABEL.percCDI}
            value={item.percCDIAnoRecursoFinanceiro === 0 ? 0 : item.percCDIAnoRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercRentabilidade12MRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRentabilidade12MRecursoFinanceiro`}
            label={LABEL.percRentabilidade12M}
            value={item.percRentabilidade12MRecursoFinanceiro === 0 ? 0 : item.percRentabilidade12MRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercCDI12MRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percCDI12MRecursoFinanceiro`}
            label={LABEL.percCDI}
            value={item.percCDI12MRecursoFinanceiro === 0 ? 0 : item.percCDI12MRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercRentabilidade24MRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRentabilidade24MRecursoFinanceiro`}
            label={LABEL.percRentabilidade24M}
            value={item.percRentabilidade24MRecursoFinanceiro === 0 ? 0 : item.percRentabilidade24MRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const PercCDI24MRecursoFinanceiro = ({ item, ind, handleChange, labelCurto }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percCDI24MRecursoFinanceiro`}
            label={LABEL.percCDI}
            value={item.percCDI24MRecursoFinanceiro === 0 ? 0 : item.percCDI24MRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
        />
    )
}

export const Vencimento = ({ item, ind, setFieldValue }) => {

    return (
        <MuiPickersUtilsProviderPadrao>
            <KeyboardDatePickerPadrao
                name={`recursosFinanceiros[${ind}].vencimento`}
                label={LABEL.vencimento}
                value={item.vencimento}
                onChange={(date) =>
                    setFieldValue(
                        `recursosFinanceiros[${ind}].vencimento`,
                        date
                    )
                }
            />
        </MuiPickersUtilsProviderPadrao>
    )
}

export const NomeAcao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`recursosFinanceiros[${ind}].nomeAcao`}
            label={LABEL.nomeAcao}
            value={item.nomeAcao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.nomeAcao}
        />
    )
}

export const PercRentabilidadeAnualRecursoFinanceiro = ({ item, ind, handleChange, labelCurto, expandiu }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].percRentabilidadeAnualRecursoFinanceiro`}
            label={
                labelCurto
                    ?
                        LABEL.percRentabilidadeAnualCurto
                    :
                        LABEL.percRentabilidadeAnual
            }
            value={item.percRentabilidadeAnualRecursoFinanceiro === 0 ? 0 : item.percRentabilidadeAnualRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.percRentabilidadeRecursoFinanceiro}
            numMax={NUMMAX.percRentabilidadeRecursoFinanceiro}
            disabled={expandiu}
        />
    )
}

export const TaxaInflacaoAnualRecursoFinanceiro = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`recursosFinanceiros[${ind}].taxaInflacaoAnualRecursoFinanceiro`}
            label={LABEL.taxaInflacaoAnual}
            value={item.taxaInflacaoAnualRecursoFinanceiro === 0 ? 0 : item.taxaInflacaoAnualRecursoFinanceiro || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const TipoMomentoTributacaoIR = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`recursosFinanceiros[${ind}].tipoMomentoTributacaoIR`}
            label={LABEL.tipoMomentoTributacaoIR}
            value={item.tipoMomentoTributacaoIR || ''}
            onChange={handleChange}
            list={tipoMomentoTributacaoIRList}
        />
    )
}

export const PercIR = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`recursosFinanceiros[${ind}].percIR`}
            label={LABEL.percIR}
            value={item.percIR === 0 ? 0 : item.percIR || ''}
            onChange={handleChange}
            numMin={NUMMIN.percIR}
            numMax={NUMMAX.percIR}
        />
    )
}

export const TempoMinimoEntreAportesResgatesCalculoIRAnos = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`recursosFinanceiros[${ind}].tempoMinimoEntreAportesResgatesCalculoIRAnos`}
            label={LABEL.tempoMinimoEntreAportesResgatesCalculoIRAnos}
            value={
                item.tempoMinimoEntreAportesResgatesCalculoIRAnos === 0
                    ?
                        0
                    :
                        item.tempoMinimoEntreAportesResgatesCalculoIRAnos || ''
            }
            onChange={handleChange}
            numMin={NUMMIN.tempoMinimoEntreAportesResgatesCalculoIRAnos}
            numMax={NUMMAX.tempoMinimoEntreAportesResgatesCalculoIRAnos}
        />
    )
}

//export const TaxaAnual = ({ item, ind, handleChange }) => {
//
//    return (
//        <TextValidatorNumber
//            name={`recursosFinanceiros[${ind}].taxaAnual`}
//            label={LABEL.taxaAnual}
//            value={item.taxaAnual || ''}
//            onChange={handleChange}
//            numMin={NUMMIN.taxa}
//            numMax={NUMMAX.taxa}
//        />
//    )
//}

export const DescricaoOutros = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`recursosFinanceiros[${ind}].descricaoOutros`}
            label={LABEL.descricao}
            value={item.descricaoOutros || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoRecursosFinanceirosOutros}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoOutros = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoRecursosFinanceirosOutros}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`recursosFinanceiros[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
            disabled={/*item.idReceitaMensal > 0 || */item.idPergunta > 0}
        />
    )
}